/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SWOTTopicVoteBatchReport', 'model/SWOTTopicVoteBatchReportPaginationSlice', 'model/SWOTTopicVoteBatch'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SWOTTopicVoteBatchReport'), require('../model/SWOTTopicVoteBatchReportPaginationSlice'), require('../model/SWOTTopicVoteBatch'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SWOTTopicVoteBatchApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SWOTTopicVoteBatchReport, root.ForStractionServiceApi.SWOTTopicVoteBatchReportPaginationSlice, root.ForStractionServiceApi.SWOTTopicVoteBatch);
  }
}(this, function(ApiClient, SWOTTopicVoteBatchReport, SWOTTopicVoteBatchReportPaginationSlice, SWOTTopicVoteBatch) {
  'use strict';

  /**
   * SWOTTopicVoteBatch service.
   * @module api/SWOTTopicVoteBatchApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new SWOTTopicVoteBatchApi. 
   * @alias module:api/SWOTTopicVoteBatchApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the sWOTTopicVoteBatchLoadGet operation.
     * @callback module:api/SWOTTopicVoteBatchApi~sWOTTopicVoteBatchLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SWOTTopicVoteBatchReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/SWOTTopicVoteBatchApi~sWOTTopicVoteBatchLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SWOTTopicVoteBatchReport}
     */
    this.sWOTTopicVoteBatchLoadGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTTopicVoteBatchLoadGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling sWOTTopicVoteBatchLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SWOTTopicVoteBatchReport;

      return this.apiClient.callApi(
        '/SWOTTopicVoteBatch/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sWOTTopicVoteBatchSearchSlicePut operation.
     * @callback module:api/SWOTTopicVoteBatchApi~sWOTTopicVoteBatchSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SWOTTopicVoteBatchReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/SWOTTopicVoteBatch} body 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.atHistoryPoint 
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {module:api/SWOTTopicVoteBatchApi~sWOTTopicVoteBatchSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SWOTTopicVoteBatchReportPaginationSlice}
     */
    this.sWOTTopicVoteBatchSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sWOTTopicVoteBatchSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sWOTTopicVoteBatchSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'atHistoryPoint': opts['atHistoryPoint'],
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'order': opts['order']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SWOTTopicVoteBatchReportPaginationSlice;

      return this.apiClient.callApi(
        '/SWOTTopicVoteBatch/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
